import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router';
import RouterComponent from './RouterComponent';

function App() {


  /**
 * @author Vishal Lohbande
 * @hook useEffect
 *
 * useEffect - Adds global event listeners to restrict access to developer tools and context menu.
 *
 * Behavior:
 * - Disables the right-click context menu to prevent users from inspecting the page.
 * - Blocks keyboard shortcuts commonly used to open browser DevTools:
 *   - F12 (opens DevTools)
 *   - Ctrl + Shift + I (opens DevTools)
 *   - Ctrl + U (view page source)
 *
 * Clean-Up:
 * - Removes the event listeners on component unmount to prevent memory leaks or duplicate bindings.
 *
 * Note:
 * - This is a basic deterrent and does not provide security against advanced users.
 * - Uses deprecated `keyCode` for compatibility; modern implementations may prefer `event.key` or `event.code`.
 */
  // useEffect(() => {
  //   document.addEventListener("contextmenu", (e) => {
  //     e.preventDefault();
  //   });
  //   document.addEventListener(
  //     "keydown",
  //     (event) => {
  //       if (event.keyCode === 123) {
  //         event.preventDefault();
  //       } else if (event.ctrlKey && event.shiftKey && event.keyCode === 73) {
  //         event.preventDefault();
  //       } else if (event.ctrlKey && event.keyCode === 85) {
  //         event.preventDefault();
  //       }
  //     },
  //     false
  //   );
  // }, []);

  return (
    <BrowserRouter >
        <RouterComponent />
    </BrowserRouter>
  );
}

export default App;
